<div class="email-update-body flex-row flex-justify-space-around flex-align-center from-group--row-wrapper mail-password-wrapper">
    <mat-form-field class="flex-row-100 mobile-form-field">
        <mat-label>{{ 'dottnet.email.update.newEmail' | translate }}</mat-label>
        <input type="email" matInput [formControl]="emailControl" (keydown.enter)="onSubmit()" />
        @if (emailControl.hasError('required') || emailControl.hasError('email')) {
        <mat-error>{{ 'dottnet.field.error.email' | translate }}</mat-error>
        } @else if (emailControl.hasError('mailExistence')) {
        <mat-error>{{ 'dottnet.field.error.mailExistence' | translate }}</mat-error>
        }
    </mat-form-field>
    <button type="button" id="saveEmailButton" (click)="onSubmit()" mat-raised-button color="accent">
        {{ 'dottnet.button.save' | translate }}
    </button>
    @if (showCancel()) {
    <button type="button" id="cancelEmailButton" (click)="onCancel()" mat-stroked-button>
        {{ 'dottnet.emailConfirm.button.cancel' | translate }}
    </button>
    }
</div>
